const componentsLinkMixins = {
  data() {
    return {
      componentName: this.$options._componentTag
    };
  },

  computed: {
    componentIsDownload() {
      return (
        this.attributesSchemaComponent() &&
        'download' in this.attributesSchemaComponent() &&
        this.attributesSchemaComponent().download === true
      );
    },

    computedValue() {
      if (this.componentIsDownload) {
        return null;
      }

      if ('token' in this.schema) {
        var path = `#/RedirectExternalAuthenticated?url=${this.value || this.attributesSchemaComponent().href}&c=${
          this.schema.token.client_id
        }&s=${this.schema.token.scope}`;
        if ('queryParam' in this.schema.token) {
          path += `&qp=${this.schema.token.queryParam}`;
        }

        return path;
      }
      // Retorna o valor ou o href do attributesSchemaComponent, ou null se não houver
      // Antes, estávamos acessando diretamente this.attributesSchemaComponent().href,
      // o que poderia causar um erro TypeError se attributesSchemaComponent() retornasse undefined.
      // Agora, estamos verificando se attributes é undefined antes de acessar a propriedade href.
      const attributes = this.attributesSchemaComponent();
      return this.value || (attributes && attributes.href) || null;
    }
  },

  methods: {
    attributesSchemaComponent() {
      const attributes = {
        'field-i4proCardLinkIcon': this.schema.attributesCard,
        'field-i4proButtonLink': this.schema.attributesButton
      };

      return attributes[this.componentName];
    },

    showMessage(color, text) {
      this.$store.dispatch('notification/showNotification', { color, text, showIconNotification: false });
    },

    async checkIsFileDownload() {
      if ('token' in this.schema || !this.value) {
        return;
      }

      const typeFile = ['zip', 'rar', 'json'];
      const keywords = this.value.split('.').pop();

      // Verifica se o link contém extensão de arquivo ao final da URL
      if (typeFile.indexOf(keywords) !== -1) {
        //this.downloadItem({url: this.value})
        let objectResponse = await this.downloadWithProgress(this.value).then(
          function (response) {
            console.log(response);
            return response;
          },
          function (response) {
            console.log(response);
            return response;
          }
        );

        objectResponse.success
          ? this.showMessage('green', 'Processamento efetuado com sucesso')
          : this.showMessage('red', `${objectResponse.statusCode}-${objectResponse.message}`);
      }
    },

    async downloadWithProgress(url) {
      return new Promise(function (resolve, reject) {
        const startTime = new Date().getTime();
        const request = new XMLHttpRequest();

        request.responseType = 'blob';
        request.open('get', url, true);

        request.onreadystatechange = function () {
          let objectResponse = {
            statusCode: '',
            message: '',
            success: false
          };

          if (this.readyState == 4 && (this.status == 200 || this.status == 304)) {
            const imageURL = window.URL.createObjectURL(this.response);
            const anchor = document.createElement('a');
            anchor.href = imageURL;
            // anchor.download = "DownloadTeste";
            anchor.target = '_blank';
            document.body.appendChild(anchor);
            anchor.click();

            objectResponse.statusCode = this.status;
            objectResponse.message = this.statusText;
            objectResponse.success = true;

            resolve(objectResponse);
          } else if (this.status === 404) {
            objectResponse.statusCode = this.status;
            objectResponse.message = this.statusText;
            objectResponse.success = false;

            reject(objectResponse);
          }
        };

        request.onprogress = function (e) {
          const percent_complet = Math.floor((e.loaded / e.total) * 100);

          const duration = (new Date().getTime() - startTime) / 1000;
          const bps = e.loaded / duration;

          const kbps = Math.floor(bps / 1024);

          const time = (e.total - e.loaded) / bps;
          const seconds = Math.floor(time % 60);
          const minutos = Math.floor(time / 60);

          console.log(`${percent_complet}% - ${kbps} Kbps - ${minutos} min ${seconds} sec remaining`);
        };

        request.send();
      });
    }
  }
};

export default componentsLinkMixins;
